import { render } from "./StepThree.vue?vue&type=template&id=4fe9d816"
import script from "./StepThree.vue?vue&type=script&lang=js"
export * from "./StepThree.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\oaromasodun\\Desktop\\MarinePortal\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__